// src/components/HeroSection.jsx
import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './HeroSection.css';

const HeroSection = () => {
    const appName = "MyFit Menu AI";
    const videoSrc = "/videos/hero-video.mp4";
    const posterSrc = "/images/hero-poster.jpg";
    const logoSrc = "/logo-light.png"; // Ajusta esta ruta si tu logo está en otro lugar

    return (
        <section className="hero-section-video position-relative py-5 d-flex flex-column justify-content-center align-items-center">
            <video
                autoPlay
                loop
                muted
                playsInline
                poster={posterSrc}
                className="hero-video-bg"
                id="heroVideoBackground"
            >
                <source src={videoSrc} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <div className="video-overlay"></div>

            <Container className="position-relative text-center hero-content" style={{ zIndex: 2 }}>


                <h1 className="display-3 fw-bolder mb-4 hero-title animated-fade-in-down">
                    Smarter Nutrition Starts with <span className="highlight-text">{appName}</span> <span role="img" aria-label="rocket">🚀</span>
                </h1>

                <img src={logoSrc} alt={`${appName} logo`} className="mb-1 hero-logo animated-fade-in-down" height="150" />

                <p className="lead mb-5 fs-4 hero-subtitle animated-fade-in-up delay-1s">
                    Upload meals, scan barcodes, and unlock personalized health insights in seconds—powered by next-gen AI.
                </p>

                <Button
                    as={Link}
                    to="/register"
                    variant="success"
                    size="lg"
                    className="px-5 py-3 shadow-lg fw-bold rounded-pill hero-cta-button animated-fade-in-up delay-2s"
                >
                    Get Started Free Today!
                </Button>
            </Container>
        </section>
    );
};

export default HeroSection;
